import React, { Suspense } from "react";
import { Navigation } from "./components/navigation";
import { Header } from "./components/header";
//import { Features } from "./components/features";
import { About } from "./components/about";
import { Services } from "./components/services";
import { Gallery } from "./components/gallery";
import { Personal } from "./components/personal";
import { Contact } from "./components/contact";
import { Cookie } from "./components/cookie";
import { Benefits } from "./components/benefits";
import SmoothScroll from "smooth-scroll";
import i18n from 'i18next';
import "./App.css";
import "./styles/style.scss"

import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Impressum } from "./components/impressum";

export const scroll = new SmoothScroll('a[href*="#"]', {
  speed: 1000,
  speedAsDuration: true,
});

const App = () => {
  if (localStorage.getItem("lang") === null) i18n.changeLanguage('de');
  else i18n.changeLanguage(localStorage.getItem("lang"));

  return (
    <Suspense fallback="...loading">   
      <BrowserRouter>
      <Routes>
         <Route path="/" element={
              <>
              <Cookie />
              <div>
                <Navigation />
                <Header />        
                <About />  
                <Personal />              
                <Benefits />        
                <Services />      
                <Gallery />
                <Contact />
              </div>
              </>
         } />
         <Route path="/impressum" element={<Impressum />} />
      </Routes>
      </BrowserRouter>
    </Suspense>
  );
};

export default App;

//<Testimonials data={landingPageData.Testimonials} />
//<Team data={landingPageData.Team} />